import React, { useState } from "react";
import "./Bet_Select_section.css"
import ColorButtons from "../ColorButtons/ColorButtons";
import ActionButtons from "../ActionButtons/ActionButtons";
import NumberGrid from "../NumberGrid/NumberGrid";
import WinGoModal from "../../Common/Common_Component/Common_Modal/WinGoModal/WinGoModal";
import { useSocket } from "../../../utils/socket";

const BET_CUTOFF = 10;

function Bet_Select_section({ mainActiveTab }) {
  const [modalData, setModalData] = useState({ open: false, value: '', type: '', amount: 0, multiply: "1", bet_type: "number" });
  const [activeBtn, setActiveBtn] = useState("X1");

  const [time, setTime] = useState(0);

  useSocket(`color_prediction_timer_${mainActiveTab?.id}sec`, async (data) => {
    await setTime(data?.time);
  });

  const minutes = String(Math.floor(time / 60)).padStart(2, "0");
  const seconds = String(time % 60).padStart(2, "0");


  return (
    <>


      <section className="Bet_Select_section">
        {(time <= 5 && time >= 0) && (   // 🔥 change condition as needed
          <div className="timer-overlay">
            <div className="timer-digit-wrapper">


              {/* <div className="timer-digit-box">{minutes[0]}</div>
              <div className="timer-digit-box">{minutes[1]}</div>

     
              <div className="colon">:</div> */}

              {/* Seconds */}
              <div className="timer-digit-box">{seconds[0]}</div>
              <div className="timer-digit-box">{seconds[1]}</div>

            </div>
          </div>
        )}
        <ColorButtons modalData={modalData} setModalData={setModalData} />
        <NumberGrid modalData={modalData} setModalData={setModalData} />
        <ActionButtons modalData={modalData} setModalData={setModalData} />
      </section>

      {(modalData.open && (time >= BET_CUTOFF)) && (
        <WinGoModal
          mainActiveTab={mainActiveTab}
          selectedValue={modalData.value}
          type={modalData.type}
          bet_type={modalData.bet_type}
          multiply={modalData.multiply}
          onClose={() => setModalData({ ...modalData, open: false })}
        />
      )}
    </>
  );
}

export default Bet_Select_section;
